import { Menu } from '@mui/material'
import React from 'react'
import ListMenu from '../../../../../commom/ListMenu'
import { useParams } from 'react-router-dom';
import ElementChildrenDialog from '../DialogChildren/DialogChildren';

const MenuElementChildren = ({
  baseElement, setChange,
  data, setData, 
  menuChildren, handleMenuChildrenClose,
  modalChildren, setModalElement, setModalChildren 
}) => {
  const { curriculumId, elementId } = useParams();

  return (
    <>
      { modalChildren &&
        <ElementChildrenDialog
          show={!!modalChildren}
          type={modalChildren?.type}
          title={modalChildren.type === 'edit' ? `Edit ${baseElement.name}` : modalChildren?.type}
          data={{
            ...modalChildren?.form?.children,
            parent: modalChildren?.form?.parent
          }}
          onClose={() => {
            setModalChildren(null)
            setData({})
          }}
          baseElement={baseElement}
          setChange={setChange}
        />
      }
      { menuChildren &&
        <Menu
          id={`menuChildren-${curriculumId}-${elementId}`}
          MenuListProps={{
            style: { width: '260px' },
            className: "list-menuChildren p-0"
          }}
          keepMounted
          open={menuChildren.mouseY !== null}
          onClose={handleMenuChildrenClose}
          anchorReference="anchorPosition"
          anchorPosition={
            menuChildren.mouseY !== null && menuChildren.mouseX !== null
              ? { top: menuChildren.mouseY, left: menuChildren.mouseX }
              : undefined
          }
        >
          <ListMenu
            id={`menuChildren-list-${curriculumId}-${elementId}`}
            items={[
                { 
                  label: 'Edit',
                  icon: 'pencil',
                  permissions: true,
                  onClick: () => setModalChildren({
                    type: 'edit children',
                    form: data
                  })
                },
                { 
                  label: 'Clone',
                  icon: 'clone',
                  permissions: true,
                  onClick: () => setModalChildren({
                    type: 'clone children',
                    form: {
                      ...data,
                      parent: data.parent,
                      children: {
                        ...data.children,
                        childrenId: data?.children?._id,
                        elementId: data?.element?._id
                      },
                      element: {
                        childrenId: data?.children?._id,
                        elementId: data?.element?._id
                      }
                    }
                  })
                },
                { 
                  label: 'Delete',
                  icon: 'trash-alt',
                  permissions: true,
                  onClick: () => setModalChildren({
                    type: 'delete children',
                    form: data
                  })
                },
                { 
                  divider: true,
                  label: 'Add element',
                  icon: 'plus',
                  permissions: true,
                  onClick: () => setModalElement({
                    type: 'add',
                    form: {
                      parent: data.parent,
                      parentElements: data.parentElements,
                      elementIds: data.elementIds,
                      element: {
                        childrenId: data?.children?._id
                      }
                    }
                  })
                }
              ]
              .filter((item) => item.permissions)
              .map((item) => ({ 
                ...item, 
                onClick: () => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  handleMenuChildrenClose()
                }
              }))
            } 
          />
        </Menu>   
      }
    </>
  )
}

export default MenuElementChildren